
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Add" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.5766"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5766",
    "ar-eg": "static-1.5766",
    "bg": "static-1.5766",
    "bn": "static-1.5766",
    "ca-es": "static-1.5766",
    "cs": "static-1.5766",
    "da": "static-1.5766",
    "de": "static-1.5766",
    "el": "static-1.5766",
    "en-gb": "static-1.5766",
    "en": "static-1.5766",
    "es-mx": "static-1.5766",
    "es": "static-1.5766",
    "et": "static-1.5766",
    "fi": "static-1.5766",
    "fr-ca": "static-1.5766",
    "fr": "static-1.5766",
    "he-il": "static-1.5766",
    "hi": "static-1.5766",
    "hr": "static-1.5766",
    "hu": "static-1.5766",
    "id": "static-1.5766",
    "it": "static-1.5766",
    "ja": "static-1.5766",
    "ko": "static-1.5766",
    "lt": "static-1.5766",
    "ms": "static-1.5766",
    "nl": "static-1.5766",
    "no": "static-1.5766",
    "pl": "static-1.5766",
    "pt-br": "static-1.5766",
    "pt-pt": "static-1.5766",
    "ro": "static-1.5766",
    "ru": "static-1.5766",
    "sk": "static-1.5766",
    "sl": "static-1.5766",
    "sv": "static-1.5766",
    "th": "static-1.5766",
    "tl": "static-1.5766",
    "tr": "static-1.5766",
    "uk": "static-1.5766",
    "vi": "static-1.5766",
    "zh-cn": "static-1.5766",
    "zh-hk": "static-1.5766",
    "zh-tw": "static-1.5766"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.5766'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.7039"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.7039",
    "ar-eg": "static-3.7039",
    "bg": "static-3.7039",
    "bn": "static-3.7039",
    "ca-es": "static-3.7039",
    "cs": "static-3.7039",
    "da": "static-3.7039",
    "de": "static-3.7039",
    "el": "static-3.7039",
    "en-gb": "static-3.7039",
    "en": "static-3.7039",
    "es-mx": "static-3.7039",
    "es": "static-3.7039",
    "et": "static-3.7039",
    "fi": "static-3.7039",
    "fr-ca": "static-3.7039",
    "fr": "static-3.7039",
    "he-il": "static-3.7039",
    "hi": "static-3.7039",
    "hr": "static-3.7039",
    "hu": "static-3.7039",
    "id": "static-3.7039",
    "it": "static-3.7039",
    "ja": "static-3.7039",
    "ko": "static-3.7039",
    "lt": "static-3.7039",
    "ms": "static-3.7039",
    "nl": "static-3.7039",
    "no": "static-3.7039",
    "pl": "static-3.7039",
    "pt-br": "static-3.7039",
    "pt-pt": "static-3.7039",
    "ro": "static-3.7039",
    "ru": "static-3.7039",
    "sk": "static-3.7039",
    "sl": "static-3.7039",
    "sv": "static-3.7039",
    "th": "static-3.7039",
    "tl": "static-3.7039",
    "tr": "static-3.7039",
    "uk": "static-3.7039",
    "vi": "static-3.7039",
    "zh-cn": "static-3.7039",
    "zh-hk": "static-3.7039",
    "zh-tw": "static-3.7039"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.7039'}); }
})();



(function() {
  var result = { translations: { "en": { "validatedFormControl": { "validationMessageDefaults": { "input": { "validating": "Validating input...", "success": "That input is valid.", "error": "That input isn't valid." }, "email": { "validating": "Validating email address...", "success": "That email address is valid.", "error": "That email address isn't valid." }, "password": { "validating": "Validating password...", "success": "Perfect. The password you entered meets our requirements.", "error": "Sorry. The password you entered does not meet our requirements." }, "url": { "validating": "Validating URL...", "success": "That URL is valid.", "error": "That URL isn't valid." } } } } } };
  result.translationsLoaded = {
  "ui-addon-form-validation": {
    "en": "static-1.9627"
  }
};
  result.translationsAvailable = {
  "ui-addon-form-validation": {
    "af": "static-1.9627",
    "ar-eg": "static-1.9627",
    "bg": "static-1.9627",
    "bn": "static-1.9627",
    "ca-es": "static-1.9627",
    "cs": "static-1.9627",
    "da": "static-1.9627",
    "de": "static-1.9627",
    "el": "static-1.9627",
    "en-gb": "static-1.9627",
    "en": "static-1.9627",
    "es-mx": "static-1.9627",
    "es": "static-1.9627",
    "et": "static-1.9627",
    "fi": "static-1.9627",
    "fr-ca": "static-1.9627",
    "fr": "static-1.9627",
    "he-il": "static-1.9627",
    "hi": "static-1.9627",
    "hr": "static-1.9627",
    "hu": "static-1.9627",
    "id": "static-1.9627",
    "it": "static-1.9627",
    "ja": "static-1.9627",
    "ko": "static-1.9627",
    "lt": "static-1.9627",
    "ms": "static-1.9627",
    "nl": "static-1.9627",
    "no": "static-1.9627",
    "pl": "static-1.9627",
    "pt-br": "static-1.9627",
    "pt-pt": "static-1.9627",
    "ro": "static-1.9627",
    "ru": "static-1.9627",
    "sk": "static-1.9627",
    "sl": "static-1.9627",
    "sv": "static-1.9627",
    "th": "static-1.9627",
    "tl": "static-1.9627",
    "tr": "static-1.9627",
    "uk": "static-1.9627",
    "vi": "static-1.9627",
    "zh-cn": "static-1.9627",
    "zh-hk": "static-1.9627",
    "zh-tw": "static-1.9627"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-form-validation:en', {version: 'static-1.9627'}); }
})();



(function() {
  var result = { translations: { "en": { "SharedLegalStrings": { "consent": { "communicationConsentText": "{{ companyName }} is committed to protecting and respecting your privacy, and we\u2019ll only use your personal information to administer your account and to provide the products and services you requested from us. From time to time, we would like to contact you about our products and services, as well as other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick below to say how you would like us to contact you:", "communicationConsentCheckboxes": { "label": "I agree to receive other communications from {{ companyName }}." }, "implicitProcessingConsentText": "By clicking submit below, you consent to allow {{ companyName }} to store and process the personal information submitted above to provide you the content requested.", "explicitProcessingConsentText": "In order to provide you the content requested, we need to store and process your personal data. If you consent to us storing your personal data for this purpose, please tick the checkbox below.", "explicitProcessingConsentCheckboxLabel": "I agree to allow {{ companyName }} to store and process my personal data.", "privacyPolicyText": "You can unsubscribe from these communications at any time. For more information on how to unsubscribe, our privacy practices, and how we are committed to protecting and respecting your privacy, please review our Privacy Policy.", "legitimateInterestPrivacyPolicyText": "{{ companyName }} needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our Privacy Policy." } } } } };
  result.translationsLoaded = {
  "SharedLegalStrings": {
    "en": "static-1.1288"
  }
};
  result.translationsAvailable = {
  "SharedLegalStrings": {
    "af": "static-1.1288",
    "ar-eg": "static-1.1288",
    "bg": "static-1.1288",
    "bn": "static-1.1288",
    "ca-es": "static-1.1288",
    "cs": "static-1.1288",
    "da": "static-1.1288",
    "de": "static-1.1288",
    "el": "static-1.1288",
    "en-gb": "static-1.1288",
    "en": "static-1.1288",
    "es-mx": "static-1.1288",
    "es": "static-1.1288",
    "et": "static-1.1288",
    "fi": "static-1.1288",
    "fr-ca": "static-1.1288",
    "fr": "static-1.1288",
    "he-il": "static-1.1288",
    "hi": "static-1.1288",
    "hr": "static-1.1288",
    "hu": "static-1.1288",
    "id": "static-1.1288",
    "it": "static-1.1288",
    "ja": "static-1.1288",
    "ko": "static-1.1288",
    "lt": "static-1.1288",
    "ms": "static-1.1288",
    "nl": "static-1.1288",
    "no": "static-1.1288",
    "pl": "static-1.1288",
    "pt-br": "static-1.1288",
    "pt-pt": "static-1.1288",
    "ro": "static-1.1288",
    "ru": "static-1.1288",
    "sk": "static-1.1288",
    "sl": "static-1.1288",
    "sv": "static-1.1288",
    "th": "static-1.1288",
    "tl": "static-1.1288",
    "tr": "static-1.1288",
    "uk": "static-1.1288",
    "vi": "static-1.1288",
    "zh-cn": "static-1.1288",
    "zh-hk": "static-1.1288",
    "zh-tw": "static-1.1288"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:SharedLegalStrings:en', {version: 'static-1.1288'}); }
})();



(function() {
  var result = { translations: { "en": { "sanitizedEmail": { "imageError": "This image is too large to display.", "expandEmailButtonText": "Expand", "collapseEmailButtonText": "Collapse", "hideEmailRepliesButtonText": "Hide trimmed content", "showEmailRepliesButtonText": "View trimmed content" } } } };
  result.translationsLoaded = {
  "sanitize-text": {
    "en": "static-1.6792"
  }
};
  result.translationsAvailable = {
  "sanitize-text": {
    "af": "static-1.6792",
    "ar-eg": "static-1.6792",
    "bg": "static-1.6792",
    "bn": "static-1.6792",
    "ca-es": "static-1.6792",
    "cs": "static-1.6792",
    "da": "static-1.6792",
    "de": "static-1.6792",
    "el": "static-1.6792",
    "en-gb": "static-1.6792",
    "en": "static-1.6792",
    "es-mx": "static-1.6792",
    "es": "static-1.6792",
    "et": "static-1.6792",
    "fi": "static-1.6792",
    "fr-ca": "static-1.6792",
    "fr": "static-1.6792",
    "he-il": "static-1.6792",
    "hi": "static-1.6792",
    "hr": "static-1.6792",
    "hu": "static-1.6792",
    "id": "static-1.6792",
    "it": "static-1.6792",
    "ja": "static-1.6792",
    "ko": "static-1.6792",
    "lt": "static-1.6792",
    "ms": "static-1.6792",
    "nl": "static-1.6792",
    "no": "static-1.6792",
    "pl": "static-1.6792",
    "pt-br": "static-1.6792",
    "pt-pt": "static-1.6792",
    "ro": "static-1.6792",
    "ru": "static-1.6792",
    "sk": "static-1.6792",
    "sl": "static-1.6792",
    "sv": "static-1.6792",
    "th": "static-1.6792",
    "tl": "static-1.6792",
    "tr": "static-1.6792",
    "uk": "static-1.6792",
    "vi": "static-1.6792",
    "zh-cn": "static-1.6792",
    "zh-hk": "static-1.6792",
    "zh-tw": "static-1.6792"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:sanitize-text:en', {version: 'static-1.6792'}); }
})();



(function() {
  var result = { translations: { "en": { "a11y": { "viewSpecificPage": "Now displaying page {{ pageNumber }}", "hiddenPDFControls": "Navigate between pages of this document", "previousPage": "Go to previous page", "nextPage": "Go to next page", "pageSelectorButton": "Page {{ pageNumber }}", "pageSelectorContainer": "Select a page", "senderProfile": "Book a meeting or send an email to {{ email }}", "downloadButton": "Download this document to your computer", "shareButton": "Access a shareable link for this document", "skipToDocument": "Skip links to display main content.", "brandingAltTextNoCompany": "Company logo", "brandingAltText": "{{ companyName }} logo" }, "app": { "htmlTitle": "Documents | HubSpot", "title": "Documents" }, "view": { "notAvailable": "This document is temporarily unavailable. Try again after {{ date }}.", "notFound": "But that page is nowhere to be found", "error": "Sorry, looks like the document you were looking for is unavailable.", "toolbar": { "download": "Download", "share": "Share", "shareThisLink": "Share this link", "sender": { "meetingsLink": "Let's meet", "emailLink": "Email me" }, "addLogo": "Add your logo" }, "viewerInfo": { "header": { "title": { "withName": "{{ name }} shared this document with you.", "noName": "Someone shared this document with you." }, "subtitle": "Please enter your email address to continue" }, "submit": "Submit" }, "previewAlert": { "title": "Preview - do not share this page", "description": "To send a tracked link, return to the {{ documentSummaryLink }}.", "documentSummaryLink": "document summary" }, "utm": { "shareYourFiles": "This document was shared using", "getHubSpotFree": "Try HubSpot for free" }, "gdprSubmissionError": { "title": "There was a problem submitting the form.", "message": "Please refresh the page and try again. If the problem persists, contact the document owner." } }, "pdf": { "error": { "errorTitle": "Well, this is disappointing", "errorDescription": "Sorry, looks like the document you were looking for is unavailable.", "tryAgain": "Refresh and try again" }, "controls": { "page": "Page {{ pageNumber }} of {{ totalPages }}" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "documents-lib": {
    "af": "static-1.28726",
    "ar-eg": "static-1.28726",
    "bg": "static-1.28726",
    "bn": "static-1.28726",
    "ca-es": "static-1.28726",
    "cs": "static-1.28726",
    "da": "static-1.28726",
    "de": "static-1.28726",
    "el": "static-1.28726",
    "en-gb": "static-1.28726",
    "en": "static-1.28726",
    "es-mx": "static-1.28726",
    "es": "static-1.28726",
    "et": "static-1.28726",
    "fi": "static-1.28726",
    "fr-ca": "static-1.28726",
    "fr": "static-1.28726",
    "he-il": "static-1.28726",
    "hi": "static-1.28726",
    "hr": "static-1.28726",
    "hu": "static-1.28726",
    "id": "static-1.28726",
    "it": "static-1.28726",
    "ja": "static-1.28726",
    "ko": "static-1.28726",
    "lt": "static-1.28726",
    "ms": "static-1.28726",
    "nl": "static-1.28726",
    "no": "static-1.28726",
    "pl": "static-1.28726",
    "pt-br": "static-1.28726",
    "pt-pt": "static-1.28726",
    "ro": "static-1.28726",
    "ru": "static-1.28726",
    "sk": "static-1.28726",
    "sl": "static-1.28726",
    "sv": "static-1.28726",
    "th": "static-1.28726",
    "tl": "static-1.28726",
    "tr": "static-1.28726",
    "uk": "static-1.28726",
    "vi": "static-1.28726",
    "zh-cn": "static-1.28726",
    "zh-hk": "static-1.28726",
    "zh-tw": "static-1.28726"
  }
};
  hns('I18n', result);

})();


